import { Component, Input } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';
import { WorkFlow } from '@core/models/auxiliary-company-models';
import { Company } from '@core/models/company';
import { CommentService } from '@core/services/comment.service';
import { VotingService } from '@core/services/voting.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Nullable } from 'primeng/ts-helpers';
import { ModalUtilsService } from 'src/app/services/modal-utils.service';
import { getActiveOrLastICVotingWorkflow, getCurrentUserVotingComment, getCurrentUserVotingScore, getVotingBackgroundClasses } from "src/app/utils/company-utils";

@Component({
  selector: 'bpc-summary-column',
  templateUrl: './summary-column.component.html',
  styleUrl: './summary-column.component.scss'
})
export class SummaryColumnComponent {

  get isMobile(){
    return this.deviceDetectorService.isMobile();
  }

  constructor(
    private authService: AuthService,
    private votingService: VotingService,
    private modalUtilsService: ModalUtilsService,
    public deviceDetectorService : DeviceDetectorService
  )
  {
  }
  @Input() row!: any;

  get isInvestmentCommitteeAdmin() {
    return this.authService.investmentcommitteeadmin;
  }

  showVotingStats(company: Company) {
    if (!this.isMobile){
      this.votingService.company = company;
      const workflow = getActiveOrLastICVotingWorkflow(company.workflows);
      if (workflow?.id) {
        this.votingService.showVotingStats(
          workflow.id,
          company.name,
          `${company.address?.city},  ${company.address?.country.name}`,
        );
      }
    }
  }

  voteForCompany(company: Company) {
    let modalParameters = this.modalUtilsService.modalParameters;
    modalParameters.currentModalAction = "icVoting";
    modalParameters.selectedCompany = company;
    modalParameters.icVote = getCurrentUserVotingScore(company.workflows);
    modalParameters.comment = getCurrentUserVotingComment(company.workflows);

    this.modalUtilsService.toggalModal.next(modalParameters);
  }

  votingSummaryEnable(workflows: WorkFlow[]): boolean{
    
    return !!getActiveOrLastICVotingWorkflow(workflows)?.details?.averageVote;
  }

  votingClassesWorkflow(workflows: WorkFlow[]): string {
    const score = getActiveOrLastICVotingWorkflow(workflows)?.details?.averageVote ?? 0;
    return getVotingBackgroundClasses(score);   
  }

  votingSummary(workflows: WorkFlow[]): Nullable<number> {
    return getActiveOrLastICVotingWorkflow(workflows)?.details?.averageVote ?? null;
  }
}
